import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Cookies from "js-cookie";

import HomePage from "./Components/Login/HomePage";
import EmployeeLogin from "./Components/Login/EmployeeLogin";
import DevEmployeeLogin from "./Components/Login/DevEmployeeLogin";
import ConsultantLogin from "./Components/Login/ConsultantLogin";
import DevConsultantLogin from "./Components/Login/DevConsultantLogin";
import AddConsultant from "./Components/Sidebars/Consultant/AddConsultant";
import Dashboard from "./Components/Dashboard/Dashboard";
import CDashboard from "./Components/Consultant/Cdashboard";
import PrivateRoute from "./Components/PrivateRoute";
import ConsultantPrivateRoute from "./Components/ConsultantPrivateRoute";
import ViewPostedJobs from "./Components/Sidebars/PostJob/ViewPostedJob";
import { JobProvider } from "./context/JobContext";
import RecruitmentSteps from "./Components/Dashboard/RecruitmentSteps";
import PostJobForm from "./Components/Sidebars/PostJob/PostJobForm";
import ViewCreatedJobs from "./Components/Sidebars/PostJob/ViewCreatedJobs";
import CHome from "./Components/Consultant/Ccomponents/CHome";
import CViewPublishedJobs from "./Components/Consultant/Ccomponents/CViewPublishedJobs";
import AddEmployee from "./Components/Sidebars/Employee/AddEmployee";
import JobDetails from "./Components/Sidebars/PostJob/JobDetails";
import CJobDetails from "./Components/Consultant/Ccomponents/CJobDetails";
import CSendCandidate from "./Components/Consultant/Ccomponents/CSendCandidate";
import SendCandidate from "./Components/Sidebars/PostJob/SendCandidate";
import CGetSendCandidate from "./Components/Consultant/Ccomponents/CGetSendCandidate";
import CShortListCandidate from "./Components/Consultant/Ccomponents/CShortListCandidate";
import CGetInterviewScheduled from "./Components/Consultant/Ccomponents/CGetInterviewScheduled";
import CGetSelectedCandidates from "./Components/Consultant/Ccomponents/CGetSelectedCandidates";
import CGetSentCandidateforJob from "./Components/Consultant/Ccomponents/CGetSentCandidateforJob";

import ReceivedCandidates from "./Components/Sidebars/Candidate/ReceivedCandidate";
import ShortlistCandidates from "./Components/Sidebars/Candidate/ShortListCandidate";
import InterviewScheduled from "./Components/Sidebars/Candidate/InterviewScheduled";
import GetSelectedCandidates from "./Components/Sidebars/Candidate/GetSelectedCandidates";
import RejectedCandidate from "./Components/Sidebars/Candidate/RejectedCandidate";
import GetHoldCandidate from "./Components/Sidebars/Candidate/GetHoldCandidate";
import GetBGVCandidates from "./Components/Sidebars/Candidate/GetBGVCandidates";
import GetAssessmentCandidate from "./Components/Sidebars/Candidate/GetAssessmentCandidate";
import InterviewAssesment from "./Components/Interview/InterviewAssesment";
import GetSentCandidateforJob from "./Components/Sidebars/PostJob/GetSentCandidateforJob";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import SurveyList from "./Components/Sidebars/Assessment/SurveyList";
import CreateSurvey from "./Components/Sidebars/Assessment/CreateSurvey";
import CreateQuestions from "./Components/Sidebars/Assessment/CreateQuestions";
import InterviewSchedule from "./Components/Interview/InterviewSchedule";
import ProgressBar from "./Components/ProgressBar";

const App = () => {
   const [isLoading, setIsLoading] = useState(false);
  return (
    <>
      <Router>
         <ProgressBar onLoadingChange={setIsLoading} />
        <JobProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/Employee-Login" element={<EmployeeLogin />} />
            {/* <Route path="/Employee-Login" element={<DevEmployeeLogin />} /> */}
            <Route path="/Consultant-Login" element={<ConsultantLogin />} />
            {/* <Route path="/Consultant-Login" element={<DevConsultantLogin />} /> */}

            {/* Employee Dashboard & Nested Routes */}
            <Route
              path="/Dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            >
              <Route
                index
                element={
                  <PrivateRoute>
                    <RecruitmentSteps />
                  </PrivateRoute>
                }
              />
              <Route
                path="Add-Consultant"
                element={
                  <PrivateRoute>
                    <AddConsultant />
                  </PrivateRoute>
                }
              />
              <Route
                path="Add-Employee"
                element={
                  <PrivateRoute>
                    <AddEmployee />
                  </PrivateRoute>
                }
              />
              <Route
                path="PostJob"
                element={
                  <PrivateRoute>  
                    <PostJobForm />
                  </PrivateRoute>
                }
              />
              <Route
                path="Live-Jobs"
                element={
                  <PrivateRoute>
                    <ViewPostedJobs />
                  </PrivateRoute>
                }
              />
              <Route
                path="New-Applications"
                element={
                  <PrivateRoute>
                    <ReceivedCandidates />
                  </PrivateRoute>
                }
              />
              <Route
                path="Shortlist-Candidates"
                element={
                  <PrivateRoute>
                    <ShortlistCandidates />
                  </PrivateRoute>
                }
              />
              <Route
                path="send-candidate/:jobUID"
                element={
                  <PrivateRoute>
                    <SendCandidate />
                  </PrivateRoute>
                }
              />
              <Route
                path="Draft-Jobs"
                element={
                  <PrivateRoute>
                    <ViewCreatedJobs />
                  </PrivateRoute>
                }
              />
              <Route
                path="View-Job-Details/:jobUID"
                element={
                  <PrivateRoute>
                    <JobDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="Interview-Scheduled"
                element={
                  <PrivateRoute>
                    <InterviewScheduled />
                  </PrivateRoute>
                }
              />
              <Route
                path="Get-Selected-Candidates"
                element={
                  <PrivateRoute>
                    <GetSelectedCandidates />
                  </PrivateRoute>
                }
              />
              <Route
                path="Rejected-Candidates"
                element={
                  <PrivateRoute>
                    <RejectedCandidate />
                  </PrivateRoute>
                }
              />
              <Route
                path="Hold-Candidates"
                element={
                  <PrivateRoute>
                    <GetHoldCandidate />
                  </PrivateRoute>
                }
              />
              <Route
                path="BGV-Candidates"
                element={
                  <PrivateRoute>
                    <GetBGVCandidates />
                  </PrivateRoute>
                }
              />
              <Route
                path="Assessment-Candidates"
                element={
                  <PrivateRoute>
                    <GetAssessmentCandidate />
                  </PrivateRoute>
                }
              />
              <Route
                path="SurveyList"
                element={
                  <PrivateRoute>
                    <SurveyList />
                  </PrivateRoute>
                }
              />
              <Route
                path="Survey/NewSurvey"
                element={
                  <PrivateRoute>
                    <CreateSurvey />
                  </PrivateRoute>
                }
              />
              <Route
                path="Survey/CreateQuestion/:assessmentUID"
                element={
                  <PrivateRoute>
                    <CreateQuestions />
                  </PrivateRoute>
                }
              />
              <Route
                path="Sent-Candidates-For-Job/:jobUID"
                element={
                  <PrivateRoute>
                    <GetSentCandidateforJob />
                  </PrivateRoute>
                }
              />
            </Route>

            {/* Consultant Dashboard */}
            <Route
              path="/Consultant/Dashboard"
              element={
                <ConsultantPrivateRoute>
                  <CDashboard />
                </ConsultantPrivateRoute>
              }
            >
              <Route index element={<CHome />} />
              <Route
                path="All-Jobs"
                element={
                  <ConsultantPrivateRoute>
                    <CViewPublishedJobs />
                  </ConsultantPrivateRoute>
                }
              />
              <Route
                path="Consultant-Job-Details/:jobUID"
                element={
                  <ConsultantPrivateRoute>
                    <CJobDetails />
                  </ConsultantPrivateRoute>
                }
              />
              <Route
                path="Send-Candidate/:jobUID"
                element={<CSendCandidate />}
              />
              <Route
                path="Profiles-Shared"
                element={
                  <ConsultantPrivateRoute>
                    <CGetSendCandidate />
                  </ConsultantPrivateRoute>
                }
              />
              <Route
                path="Shortlist-Candidates"
                element={
                  <ConsultantPrivateRoute>
                    <CShortListCandidate />
                  </ConsultantPrivateRoute>
                }
              />
              <Route
                path="Interview-Schedule"
                element={
                  <ConsultantPrivateRoute>
                    <CGetInterviewScheduled />
                  </ConsultantPrivateRoute>
                }
              />
              <Route
                path="Selected-Candidates"
                element={
                  <ConsultantPrivateRoute>
                    <CGetSelectedCandidates />
                  </ConsultantPrivateRoute>
                }
              />
              <Route
                path="Sent-Candidate-For-Job/:jobUID"
                element={
                  <ConsultantPrivateRoute>
                    <CGetSentCandidateforJob />
                  </ConsultantPrivateRoute>
                }
              />
            </Route>

            {/* Interview Assessment Routes */}
            <Route
              path="/Interview-Assessment/:InterviewUID"
              element={<InterviewAssesment />}
            />
            <Route
              path="/Interview-Scheduling-Request/:InterviewUID"
              element={<InterviewSchedule />}
            />

            {/* Redirect unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <footer className="text-center text-muted small py-3 border-top bg-white">
            Design and Developed by{" "}
            <span className="text-primary fw-bold">
              VRSamadhan Tech Solution
            </span>
          </footer>
        </JobProvider>
      </Router>
    </>
  );
};

export default App;
